import { twMerge } from "tailwind-merge";

import { type CellContext } from "@tanstack/react-table";

interface TableCellProps<TData> {
  cell: CellContext<TData, unknown>;
  value?: string | number;
  className?: string;
}

export const CellTextFormatter = <TData,>(props: TableCellProps<TData>) => {
  return (
    <div
      className={twMerge(
        "px-4 py-2 h-full bg-inherit text-v2-primary text-xs flex items-center gap-3",
        props.className,
      )}
      title={String(props.cell.getValue())}
      onClick={props.cell.row.getToggleSelectedHandler()}
    >
      {props.value ? props.value : String(props.cell.getValue())}
    </div>
  );
};
